import { useEffect, useState } from "react"
import { Badge, Box } from "@mui/material"
import { currencyFormat } from "src/app/utils"
import { DEFAULT_PRODUCT_IMAGE } from "src/app/constants"

const discountCodeIcon = (
  <img
    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIGQ9Ik0gNi44NTggMS4zNCBMIDExLjgyMiAxLjM0IEMgMTIuMDE1IDEuMzQgMTIuMTcyIDEuNDk2IDEyLjE3MiAxLjY5IEwgMTIuMTcyIDYuNjU0IEMgMTIuMTcyIDYuODM5IDEyLjA5OCA3LjAxNyAxMS45NjcgNy4xNDkgTCA3LjA2NCAxMi4wNTMgQyA2Ljc5IDEyLjMyNiA2LjM0NyAxMi4zMjYgNi4wNzQgMTIuMDUzIEwgMS40NTkgNy40MzggQyAxLjE4NSA3LjE2NCAxLjE4NSA2LjcyMSAxLjQ1OSA2LjQ0OCBMIDYuMzY0IDEuNTQ1IEMgNi40OTUgMS40MTMgNi42NzMgMS4zNCA2Ljg1OSAxLjM0IEwgNi44NTggMS4zNCBaIiBzdHlsZT0iZmlsbDogbm9uZTsgc3Ryb2tlOiByZ2IoMTAyLCAxMDIsIDEwMik7Ii8+CiAgPGNpcmNsZSBjeD0iOS4xIiBjeT0iNC45IiByPSIwLjciIHN0eWxlPSJzdHJva2U6IHJnYigxMDIsIDEwMiwgMTAyKTsgZmlsbDogcmdiKDEwMiwgMTAyLCAxMDIpOyIvPgogIDxwYXRoIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuMTAyIDQuODk3aC0uMDA1di4wMDVoLjAwNXYtLjAwNVoiLz4KPC9zdmc+"
    style={{ marginRight: 4 }}
  />
)

export default function CartItem({ data }) {
  let lineItemDiscount = 0

  useEffect(() => {
    console.log('CartItem', data)
  }, [])

  return (
    <Box sx={styles.itemContainer}>
      <Badge
        badgeContent={data.quantity}
        sx={{
          "& .MuiBadge-badge": {
            color: "white",
            backgroundColor: "grey",
          },
        }}
      >
        <Box sx={styles.thumbnailContainer}>
          <img
            src={
              data.merchandise?.image?.src ||
              DEFAULT_PRODUCT_IMAGE
            }
            height="50px"
            width="auto"
          />
        </Box>
      </Badge>
      <Box sx={styles.itemTitleContainer}>
        <span style={styles.itemTitle}>{data.merchandise.product.title}</span>
        {data.merchandise.title !== "Default Title" && (
          <span style={styles.itemVariantTitle}>
            {data.merchandise.title.includes("General Excise Tax - ") ? "General Excise Tax" : data.merchandise.title}
          </span>
        )}
        {data.discountAllocations.map((discountAllocation, index) => {
          const { code, discountedAmount, discountApplication } = discountAllocation
          const { targetSelection, targetType } = discountApplication

          if (
            targetType === "LINE_ITEM" &&
            targetSelection === "ENTITLED"
          ) {
            lineItemDiscount += discountedAmount.amount ?? 0
            return (
              <div key={`${data.id}-da-${index}`} style={styles.itemDiscount}>
                {discountCodeIcon}
                {code} (-
                {currencyFormat(discountedAmount.amount)})
              </div>
            )
          }
        })}
      </Box>
      <span style={styles.amount}>
        {lineItemDiscount > 0 ? (
          <>
            <div style={styles.itemOriginalPrice}>
              {currencyFormat(data.merchandise.price.amount * data.quantity)}
            </div>
            {currencyFormat(
              data.merchandise.price.amount * data.quantity - lineItemDiscount,
            )}
          </>
        ) : (
          currencyFormat(data.merchandise.price.amount * data.quantity)
        )}
      </span>
    </Box>
  )
}

const styles = {
  itemContainer: {
    display: "flex",
    alignItems: "center",
    marginTop: 2,
  },
  thumbnailContainer: {
    backgroundColor: "white",
    border: "1px solid #eee",
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 64,
    height: 64,
    textAlign: "center",
  },
  itemTitleContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginX: 2,
  },
  itemTitle: {
    fontSize: "14px",
    fontWeight: 500,
  },
  itemVariantTitle: {
    color: "#6e6e6e",
    fontSize: "12px",
    fontWeight: 400,
    marginTop: 4,
  },
  itemDiscount: {
    color: "#6e6e6e",
    display: "flex",
    fontSize: "14px",
    marginTop: "4px",
  },
  itemOriginalPrice: {
    color: "#6e6e6e",
    fontSize: "12px",
    fontWeight: "400",
    marginBottom: 4,
    textAlign: "right",
    textDecoration: "line-through",
  },
  amount: {
    fontSize: "14px",
    fontWeight: 500,
  },
}
